import React from "react";
import { Card, CardContent } from "@shared/ui/card";
import { FileIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

export type CardItem = {
  name: string;
  type: string;
  date: string;
};

type TariffCardProps = {
  title: string;
  subtitle: string;
  items: CardItem[];
  onViewAllClick?: () => void;
  viewAllPath?: string;
};

const TariffCard = ({ title, subtitle, items, onViewAllClick, viewAllPath }: TariffCardProps) => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    if (onViewAllClick) {
      onViewAllClick();
    }
    if (viewAllPath) {
      navigate(viewAllPath);
    }
  };

  return (
    <Card className="rounded-xl">
      <CardContent className="pt-6">
        <p className="text-base font-semibold text-gray-900 mb-1">{title}</p>
        <p className="text-sm text-gray-500 mb-4">{subtitle}</p>

        <ul className="space-y-4">
          {items.map((item, index) => (
            <li key={index} className="flex justify-between items-start">
              <div className="flex items-start gap-3">
                <div className="rounded-full bg-blue-100 p-2">
                  <FileIcon className="text-blue-500 w-4 h-4" />
                </div>
                <div className="flex flex-col">
                  <span className="font-medium text-gray-900">{item.name}</span>
                  {item.type && (
                    <span className="text-sm text-gray-500">{item.type}</span>
                  )}
                </div>
              </div>
              <span className="text-xs text-gray-400 mt-1 whitespace-nowrap">{item.date}</span>
            </li>
          ))}
        </ul>

        <button
          onClick={handleViewAll}
          className="text-sm text-blue-600 mt-6 inline-block hover:underline"
        >
          View all {title.toLowerCase()}
        </button>
      </CardContent>
    </Card>
  );
};

export default TariffCard;
